

const getSectors = (data) => {
    const sectors = [];
    const seenSectors = new Set();
    let idCounter = 1;
    if (Array.isArray(data)) {
        data?.forEach(item => {
            if (item.sector && !seenSectors.has(item.sector)) {
                seenSectors.add(item.sector);

                sectors.push({
                    displayText: item.sector,
                    id: idCounter.toString(),
                    isBadge: false
                });

                idCounter++;
            }
        });
    }
    return sectors;
}

/* istanbul ignore next */
const getSectorsV2 = (data) => {
    if (!Array.isArray(data)) return [];
    
    const seenDisplayTexts = new Set();
    const sectors = [];
    let id = 1;
    
    data.forEach((item) => {
        if (item && item.name && !seenDisplayTexts.has(item.name)) {
            seenDisplayTexts.add(item.name);
            sectors.push({
                displayText: item.name,
                id: String(id),
                isBadge: false
            });
            id++;
        }
    });
    
    return sectors;
}


function getBusinessUnitsBySector(data, sectorsToInclude) {
    const result = [];
    const seenBUs = new Set();
    let idCounter = 1;
    if (Array.isArray(data)) {
        const temp = data?.filter(item => sectorsToInclude.includes(item.sector))
        temp?.forEach(item => {
            if (item.sector && sectorsToInclude.includes(item.sector) && item.bu) {
                if (!seenBUs.has(item.bu)) {
                    seenBUs.add(item.bu);
                    result.push({
                        displayText: item.bu,
                        id: idCounter,
                        isBadge: false
                    });
                    idCounter++;
                }
            }
        });
    }

    return result;
}

/* istanbul ignore next */
function getBusinessUnitsBySectorV2(data, sectorsToInclude) {
    const filteredData = Array.isArray(data)
        ? data.filter(sector => Array.isArray(sectorsToInclude) && sectorsToInclude.includes(sector.name))
        : [];

    const uniqueBUs = [
        ...new Set(
            filteredData.flatMap(sector => Array.isArray(sector.bu) ? sector.bu.map(bu => bu.name) : [])
        )
    ];

    return uniqueBUs.map((name, index) => ({
        displayText: name,
        id: String(index + 1),
        isBadge: false
    }));
}

/* istanbul ignore next */
function getCountriesBySectorBuV2(data, sectorsToInclude, businessUnitsToInclude) {
    const filteredData = Array.isArray(data)
        ? data.filter(sector => Array.isArray(sectorsToInclude) && sectorsToInclude.includes(sector.name))
        : [];

    const uniqueCountries = [
        ...new Set(
            filteredData.flatMap(sector =>
                (Array.isArray(sector.bu) ? sector.bu : [])
                    .filter(bu => Array.isArray(businessUnitsToInclude) && businessUnitsToInclude.includes(bu.name))
                    .flatMap(bu => Array.isArray(bu.country) ? bu.country : [])
            )
        )
    ];

    return uniqueCountries.map((country, index) => ({
        displayText: country,
        id: String(index + 1),
        isBadge: false
    }));
}
/* istanbul ignore next */
    const getCategoryL0ListV2 = (data) => {
        return data.map((item, index) => ({
            displayText: item.name,
            id: String(index + 1),
            isBadge: false
        }));
    };
/* istanbul ignore next */
    const getCategoryL1ListV2 = (data, categoriesToInclude) => {
        const filteredL0 = Array.isArray(data)
            ? data.filter(item => Array.isArray(categoriesToInclude) && categoriesToInclude.includes(item.name))
            : [];

        const uniqueL1 = [
            ...new Set(
                filteredL0.flatMap(item => Array.isArray(item.l1) ? item.l1.map(l1 => l1.name) : [])
            )
        ];

        return uniqueL1.map((name, index) => ({
            displayText: name,
            id: String(index + 1),
            isBadge: false
        }));
    };
/* istanbul ignore next */
    const getCategoryL2ListV2 = (data, categoriesToInclude, categoriesL1ToInclude) => {
        const filteredL0 = Array.isArray(data)
            ? data.filter(item => Array.isArray(categoriesToInclude) && categoriesToInclude.includes(item.name))
            : [];

        const uniqueL2 = [
            ...new Set(
                filteredL0.flatMap(item =>
                    (Array.isArray(item.l1) ? item.l1 : [])
                        .filter(l1 => Array.isArray(categoriesL1ToInclude) && categoriesL1ToInclude.includes(l1.name))
                        .flatMap(l1 => Array.isArray(l1.l2) ? l1.l2 : [])
                )
            )
        ];

        return uniqueL2.map((name, index) => ({
            displayText: name,
            id: String(index + 1),
            isBadge: false
        }));
    };


const getCategoriesBySectorAndBusinessUnit = (data, sectorsToInclude, businessUnitsToInclude, isSupplier = "") => {
    const result = [];
    const uniqueNames = new Set(); // To ensure uniqueness

    // Filter the data by sectors and business units
    let filteredData = data

    if (isSupplier === "supplier" && data) {
        filteredData = data?.filter(
            item => sectorsToInclude.includes(item.sector)
        );
    }
    // else {
    //     filteredData = data?.filter(
    //         item => sectorsToInclude.includes(item.sector) && businessUnitsToInclude.includes(item.bu)
    //     );
    // }
    // console.log(filteredData)

    if (filteredData && filteredData.length > 0) {
        for (const item of filteredData) {
            const categories = item.category?.l0 || []; // Safely access `l0` (default to empty array)
            // console.log(categories)
            categories?.forEach((category, index) => {
                if (category?.name && !uniqueNames.has(category.name)) {
                    uniqueNames.add(category.name); // Add to the set
                    result.push({
                        displayText: category.name,
                        id: uniqueNames.size, // Use the size of the set for a unique ID
                        isBadge: false
                    });
                }
            });
        }
    }

    return result;
};


function getCategoriesLevel1(data, categoriesToInclude, sectorsToInclude, businessUnitsToInclude, isSupplier = "") {
    // console.log(data, categoriesToInclude, sectorsToInclude, isSupplier);

    const uniqueL1 = new Set();
    const formattedL1 = [];
    let idCounter = 1;

    let filteredData = data

    if (isSupplier === "supplier") {
        filteredData = data?.filter(
            item => sectorsToInclude.includes(item.sector)
        );
    }
    // else {
    //     filteredData = data?.filter(
    //         item => sectorsToInclude.includes(item.sector) && businessUnitsToInclude.includes(item.bu)
    //     );
    // }

    if (filteredData && filteredData.length > 0) {
        filteredData?.forEach(detail => {
            if (detail.category?.l0) {
                detail.category.l0.filter(l0Item => categoriesToInclude?.includes(l0Item.name))
                    .forEach(l0Item => {
                        if (l0Item.l1) {
                            l0Item.l1.forEach(l1Item => {
                                if (!uniqueL1.has(l1Item.name)) {
                                    uniqueL1.add(l1Item.name);
                                    formattedL1.push({
                                        displayText: l1Item.name,
                                        id: idCounter++,
                                        isBadge: false
                                    });
                                }
                            });
                        }
                    });
            }
        });
    }

    return formattedL1;
}

function getCategoriesLevel2(data, selectedL0 = [], selectedL1 = [], sectorsToInclude = [], businessUnitsToInclude = [], isSupplier = "") {
    const uniqueL2 = new Set();
    const formattedL2 = [];
    let idCounter = 1;

    let filteredData = data

    if (isSupplier === "supplier") {
        filteredData = data?.filter(
            item => sectorsToInclude.includes(item.sector)
        );
    }
    // else {
    //     filteredData = data?.filter(
    //         item => sectorsToInclude.includes(item.sector) && businessUnitsToInclude.includes(item.bu)
    //     );
    // }

    if (filteredData && filteredData.length > 0) {
        filteredData?.forEach(detail => {
            if (detail.category?.l0) {
                detail.category.l0
                    .filter(l0Item => selectedL0.includes(l0Item.name)) // Filter by selected L0
                    .forEach(l0Item => {
                        if (l0Item.l1) {
                            l0Item.l1
                                .filter(l1Item => selectedL1.includes(l1Item.name)) // Filter by selected L1
                                .forEach(l1Item => {
                                    if (l1Item.l2) {
                                        l1Item.l2.forEach(l2Item => {
                                            if (!uniqueL2.has(l2Item)) {
                                                uniqueL2.add(l2Item);
                                                formattedL2.push({
                                                    displayText: l2Item,
                                                    id: idCounter++,
                                                    isBadge: false
                                                });
                                            }
                                        });
                                    }
                                });
                        }
                    });
            }
        });
    }
    return formattedL2;
}

function getCategoriesLevel2ForSustainability(data, sectorsToInclude = []) {
    const uniqueL2 = new Set();
    const formattedL2 = [];
    let idCounter = 1;

    const filteredData = data?.filter(
        item => sectorsToInclude.includes(item.sector)
    );

    if (filteredData && filteredData.length > 0) {
        filteredData?.forEach(detail => {
            if (detail.category?.l0) {
                detail.category.l0
                    .forEach(l0Item => {
                        if (l0Item.l1) {
                            l0Item.l1
                                .forEach(l1Item => {
                                    if (l1Item.l2) {
                                        l1Item.l2.forEach(l2Item => {
                                            if (!uniqueL2.has(l2Item)) {
                                                uniqueL2.add(l2Item);
                                                formattedL2.push({
                                                    displayText: l2Item,
                                                    id: idCounter++,
                                                    isBadge: false
                                                });
                                            }
                                        });
                                    }
                                });
                        }
                    });
            }
        });
    }

    return formattedL2;
}



function getRoles(data) {
    let result = [];
    data?.map((item, index) => {
        return result.push({ displayText: item.role, id: index + 1 })
    })
    return result
}


function getYears(data) {
    return data ? data?.map((item, index) => ({ displayText: item, id: index + 1 })) : []
}



function getDropdownOptions(data) {
    return data ? data?.map((item, index) => ({ displayText: item, id: index + 1 })) : []
}



function getSectorsForResilience(data) {
    if (!data || !Array.isArray(data)) return [];

    return data.map((item, index) => ({
        displayText: item.name,
        id: index + 1
    }));
}


function getBusinessUnitForResilience(data) {
    if (!Array.isArray(data)) return [];

    let id = 1;
    const uniqueBU = new Set();

    return data.flatMap(sector =>
        (Array.isArray(sector.bu) ? sector.bu : []).filter(bu => {
            if (!uniqueBU.has(bu)) {
                uniqueBU.add(bu);
                return true;
            }
            return false;
        }).map(bu => ({
            displayText: bu,
            id: id++
        }))
    );
}




function getCategoriesL0ForSPM(data) {
    if (!data || !Array.isArray(data)) return [];

    return data.map((l0Item, index) => ({
        displayText: l0Item.name,
        id: index + 1
    }));
}


function getCategoriesL1ForSPM(data) {
    if (!data || !Array.isArray(data)) return [];

    let idCounter = 1; // Initialize ID counter
    const uniqueL1Values = [];

    data.forEach((l0Item) => {
        if (l0Item.l1 && Array.isArray(l0Item.l1)) {
            l0Item.l1.forEach((l1Item) => {
                uniqueL1Values.push({
                    displayText: l1Item.name,
                    id: idCounter++
                });
            });
        }
    });

    return uniqueL1Values;
}

function removeDuplicateDisplayTextAndAdjustIds(data) {
    const uniqueMap = new Map();

    data.forEach(item => {
        if (!uniqueMap.has(item.displayText)) {
            uniqueMap.set(item.displayText, item);
        }
    });

    const uniqueArray = Array.from(uniqueMap.values()).map((item, index) => ({
        ...item,
        id: index + 1
    }));

    return uniqueArray;
}


function getCategoriesL2ForSPM(data) {
    if (!data || !Array.isArray(data)) return [];

    let idCounter = 1;
    const uniqueL2Values = [];

    data.forEach((l0Item) => {

        if (l0Item.l1 && 
            Array.isArray(l0Item.l1)
            ) {
            l0Item.l1.forEach((l1Item) => {
                if (l1Item.l2 && 
                    Array.isArray(l1Item.l2)
                ) {
                    l1Item.l2.forEach((l2Value) => {
                        uniqueL2Values.push({
                            id: idCounter++,
                            displayText: l2Value,
                        });
                    });
                }
            });
        }
    });

    const seen = new Set();
    return uniqueL2Values.filter(item => {

        if (!seen.has(item.displayText)) 
        {
            seen.add(item.displayText);
            return true;
        }
        
        return false;
    });
    // return uniqueL2Values;
}



function getCategoriesL1ForSmartcube(data, categoryL0ToInclude) {
    if (!data || !Array.isArray(data)) return [];

    let idCounter = 1; // Initialize ID counter
    const uniqueL1Values = [];

    data.filter(l0Item => categoryL0ToInclude.includes(l0Item.name)).forEach((l0Item) => {
        if (l0Item.l1 && Array.isArray(l0Item.l1)) {
            l0Item.l1.forEach((l1Item) => {
                uniqueL1Values.push({
                    displayText: l1Item.name,
                    id: idCounter++
                });
            });
        }
    });

    return uniqueL1Values;
}


function getCategoriesL2ForSmartcube(data, categoryL0ToInclude, categoryL1ToInclude) {
    if (!data || !Array.isArray(data)) return [];

    let idCounter = 1;
    const uniqueL2Values = [];

    data?.filter(l0Item => categoryL0ToInclude.includes(l0Item.name))
        .forEach((l0Item) => {
            if (l0Item.l1 && Array.isArray(l0Item.l1)) {
                l0Item.l1
                    .filter(l1Item => categoryL1ToInclude.includes(l1Item.name))
                    .forEach((l1Item) => {
                        if (l1Item.l2 && Array.isArray(l1Item.l2)) {
                            l1Item.l2.forEach((l2Value) => {
                                uniqueL2Values.push({
                                    displayText: l2Value,
                                    id: idCounter++
                                });
                            });
                        }
                    });
            }
        });
    const seen = new Set();
    return uniqueL2Values.filter(item => {
        if (!seen.has(item.displayText)) {
            seen.add(item.displayText);
            return true;
        }
        return false;
    });
    // return uniqueL2Values;
}

/* istanbul ignore next */
function formatUserDataForVendorListApi(data) {
    const roleMap = new Map();

    data?.forEach(item => {
        const { role, roleDetail } = item;

        if (!roleMap.has(role)) {
            roleMap.set(role, {
                role: role,
                sector: new Set(),
                bu: new Set(),
                l0: new Set(),
                l1: new Set(),
                l2: new Set()
            });
        }

        const roleData = roleMap?.get(role);
        if (Array.isArray(roleDetail)) {
            roleDetail.forEach(detail => {
                const { sector, bu, category } = detail;

                if (sector) {
                    roleData.sector.add(sector.toUpperCase());
                }

                if (bu) {
                    roleData.bu.add(bu.toUpperCase());
                }

                category.l0.forEach(l0 => {
                    if (l0.name) {
                        roleData.l0.add(l0.name.toUpperCase());
                    }
                    if (l0.l1) {
                        l0.l1.forEach(l1 => {
                            if (l1.name) {
                                roleData.l1.add(l1.name.toUpperCase());
                            }
                            if (l1.l2) {
                                l1.l2.forEach(l2 => {
                                    roleData.l2.add(l2.toUpperCase());
                                });
                            }
                        });
                    }
                });
            });
        }
    });

    return Array.from(roleMap.values()).map(roleData => ({
        role: roleData.role,
        sector: Array.from(roleData.sector),
        bu: Array.from(roleData.bu),
        l0: Array.from(roleData.l0),
        l1: Array.from(roleData.l1),
        l2: Array.from(roleData.l2)
    }));
}
/* istanbul ignore next */
function extractCountriesByRole(data) {
        return data.map(({ role, sector }) => {
            const countries = [
            ...new Set(
                (sector || []).flatMap(sec =>
                (sec.bu || []).flatMap(bu => bu.country || [])
                )
            )
            ];

            return {
            role,
            country: countries
            };
        });
    }

/* istanbul ignore next */
function extractL0ByRole(data) {
    return data.map(({ role, category }) => {
        const l0 = [
            ...new Set(
                (category || []).map(cat => cat.name)
            )
        ];

        return {
            role,
            l0: l0
        };
    });
}

/* istanbul ignore next */
function extractSectorsByRole(data) {
    return data.map(({ role, sector }) => {
        const sectors = [
            ...new Set(
                (sector || []).map(sec => sec.name)
            )
        ];

        return {
            role,
            sectors: sectors
        };
    });
}

/* istanbul ignore next */
function extractBUsByRole(data) {
    return data.map(({ role, sector }) => {
        const bus = [
            ...new Set(
                (sector || []).flatMap(sec =>
                (sec.bu || []).map(bu => bu.name)
                )
            )
        ];

        return {
            role,
            bus: bus
        };
    });
}

/* istanbul ignore next */
function extractL1ByRole(data) {
    return data.map(({ role, category }) => {
        const l1 = [
            ...new Set(
                (category || []).flatMap(cat =>
                (cat.l1 || []).map(l1Item => l1Item.name)
                )
            )
        ];

        return {
            role,
            l1: l1
        };
    });
}

/* istanbul ignore next */
function extractL2ByRole(data) {
    return data.map(({ role, category }) => {
        const l2 = [
            ...new Set(
                (category || []).flatMap(cat =>
                (cat.l1 || []).flatMap(l1Item =>
                (l1Item.l2 || [])
                )
            )
            )
        ];

        return {
            role,
            l2: l2
        };
    });
}
/* istanbul ignore next */
function formatUserDataForVendorListApiwithCountry(data, userDataV2) {
    const countryArray = extractCountriesByRole(userDataV2?.details || []);
    const countryByRole = new Map(
        (countryArray || []).map(item => [item?.role, item?.country || []])
    );

    const l0Array = extractL0ByRole(userDataV2?.details || []);
    const l0ByRole = new Map(
        (l0Array || []).map(item => [item?.role, item?.l0 || []])
    );

    const sectorsArray = extractSectorsByRole(userDataV2?.details || []);
    const sectorsByRole = new Map(
        (sectorsArray || []).map(item => [item?.role, item?.sectors || []])
    );

    const busArray = extractBUsByRole(userDataV2?.details || []);
    const busByRole = new Map(
        (busArray || []).map(item => [item?.role, item?.bus || []])
    );

    const l1Array = extractL1ByRole(userDataV2?.details || []);
    const l1ByRole = new Map(
        (l1Array || []).map(item => [item?.role, item?.l1 || []])
    );

    const l2Array = extractL2ByRole(userDataV2?.details || []);
    const l2ByRole = new Map(
        (l2Array || []).map(item => [item?.role, item?.l2 || []])
    );

    return (userDataV2?.details || []).map(detail => ({
        role: detail.role,
        country: countryByRole.get(detail.role) || [],
        l0: l0ByRole.get(detail.role) || [],
        sector: sectorsByRole.get(detail.role) || [],
        bu: busByRole.get(detail.role) || [],
        l1: l1ByRole.get(detail.role) || [],
        l2: l2ByRole.get(detail.role) || []
    }));
}

/* istanbul ignore next */
function getSectorsForSupplierFilters(data) {
    if (!data || !Array.isArray(data)) return [];

    return data.map((item, index) => ({
        displayText: item.name,
        id: index + 1
    }));
}

/* istanbul ignore next */
function getBUsForSupplierFilters(data, sectorsToInclude) {

    if (!Array.isArray(data)) return [];

    let id = 1;
    const uniqueBU = new Set();

    return data
        .filter(sector=>sectorsToInclude.includes(sector.name))
        .flatMap(sector =>
        (Array.isArray(sector.bu) ? sector.bu : []).filter(bu => {
            if (!uniqueBU.has(bu)) {
                uniqueBU.add(bu);
                return true;
            }
            return false;
        }).map(bu => ({
            displayText: bu,
            id: id++
        }))
    );
    
}
/* istanbul ignore next */
function getCategoriesL0ForSupplierFilters(data) {
    if (!data || !Array.isArray(data)) return [];

    return data.map((l0Item, index) => ({
        displayText: l0Item.name,
        id: index + 1
    }));
}
/* istanbul ignore next */
function getCategoriesL1ForSupplierFilters(data, l0sToInclude) {
    if (!data || !Array.isArray(data)) return [];

    let idCounter = 1; // Initialize ID counter
    const uniqueL1Values = [];
    const uniqueL1 = new Set();

    data.forEach((l0Item) => {
        if (l0Item.l1 && Array.isArray(l0Item.l1) && l0sToInclude.includes(l0Item.name)) {
            l0Item.l1.forEach((l1Item) => {
                
                if (!uniqueL1.has(l1Item.name)) {
                    uniqueL1.add(l1Item.name);
                    uniqueL1Values.push({
                        displayText: l1Item.name,
                        id: idCounter++
                    });
                }
            });
        }
    });

    return uniqueL1Values;
}

/* istanbul ignore next */
function getCategoriesL2ForSupplierFilters(data, l0sToInclude, l1sToInclude) {
    if (!data || !Array.isArray(data)) return [];

    let idCounter = 1;
    const uniqueL2Values = [];

    data.forEach((l0Item) => {
        if (l0Item.l1 && Array.isArray(l0Item.l1) && l0sToInclude.includes(l0Item.name)) {
            l0Item.l1.forEach((l1Item) => {
                if (l1Item.l2 && Array.isArray(l1Item.l2) && l1sToInclude.includes(l1Item.name)) {
                    l1Item.l2.forEach((l2Value) => {
                        uniqueL2Values.push({
                            displayText: l2Value,
                            id: idCounter++
                        });
                    });
                }
            });
        }
    });

    const seen = new Set();
    return uniqueL2Values.filter(item => {
        if (!seen.has(item.displayText)) {
            seen.add(item.displayText);
            return true;
        }
        return false;
    });
    // return uniqueL2Values;
}
/* istanbul ignore next */
function getRegenTypesForSupplierFilters(data) {
    if (!data || !Array.isArray(data)) return [];

    return data.map((regen, index) => ({
        displayText: regen.name,
        id: index + 1
    }));
}

/* istanbul ignore next */
function getAllRegenTypeSuppliersForSupplierFilters(data) {
    if (!data || !Array.isArray(data)) return [];

    const allSuppliers= [...new Set(data.flatMap(item => item.supplier))].map((supplier, index) => ({
        displayText: supplier,
        id: index + 1
    }));
    return allSuppliers;
}

/* istanbul ignore next */
function getSuppliersUsingTypesForSupplierFilters(supplierDataWithTypes,selectedRegenType) {
    return [...new Set(
        supplierDataWithTypes
            .filter(item => selectedRegenType.includes(item.name))
            .flatMap(item => item.supplier)
    )].map((supplier, index) => ({
        displayText: supplier,
        id: index + 1
    }));;

}


/* istanbul ignore next */
function getCommoditiesForRISI(data) {
    if (!data || !Array.isArray(data)) return [];

    return data.map((commodityItem, index) => ({
        displayText: commodityItem.name,
        id: index + 1
    }));
}

/* istanbul ignore next */
function getIndexesForRISI(data, commoditiesToInclude) {
    if (!data || !Array.isArray(data)) return [];

    let idCounter = 1; // Initialize ID counter
    const uniqueIndexValues = [];
    const uniqueIndex = new Set();

    data.forEach((commodityItem) => {
        if (commodityItem.index && Array.isArray(commodityItem.index) && commoditiesToInclude.includes(commodityItem.name)) {
            commodityItem.index.forEach((indexItem) => {
                
                if (!uniqueIndex.has(indexItem.name)) {
                    uniqueIndex.add(indexItem.name);
                    uniqueIndexValues.push({
                        displayText: indexItem.name,
                        id: idCounter++
                    });
                }
            });
        }
    });

    return uniqueIndexValues;
}

/* istanbul ignore next */
function getLocationsForRISI(data, commoditiesToInclude, indexesToInclude) {
    if (!data || !Array.isArray(data)) return [];

    let idCounter = 1;
    const uniqueLocationValues = [];

    data.forEach((commodityItem) => {
        if (commodityItem.index && Array.isArray(commodityItem.index) && commoditiesToInclude.includes(commodityItem.name)) {
            commodityItem.index.forEach((IndexItem) => {
                if (IndexItem.location && Array.isArray(IndexItem.location) && indexesToInclude.includes(IndexItem.name)) {
                    IndexItem.location.forEach((locationValue) => {
                        uniqueLocationValues.push({
                            displayText: locationValue,
                            id: idCounter++
                        });
                    });
                }
            });
        }
    });

    const seen = new Set();
    return uniqueLocationValues.filter(item => {
        if (!seen.has(item.displayText)) {
            seen.add(item.displayText);
            return true;
        }
        return false;
    });
}

/* istanbul ignore next */
function getLocationForNewsFilters(data, commoditiesToInclude) {

    if (!Array.isArray(data)) return [];

    let id = 1;
    const uniqueLocation = new Set();

    return data
        .filter(commodity=>commoditiesToInclude.includes(commodity.name))
        .flatMap(commodity =>
        (Array.isArray(commodity.location) ? commodity.location : []).filter(location => {
            if (!uniqueLocation.has(location)) {
                uniqueLocation.add(location);
                return true;
            }
            return false;
        }).map(location => ({
            displayText: location,
            id: id++
        }))
    );
    
}

/* istanbul ignore next */
function getGradeOptions(data, materialsToInclude) {
    if (!data || !Array.isArray(data)) return [];

    let idCounter = 1; // Initialize ID counter
    const uniqueGradesValues = [];
    const uniqueGrades = new Set();

    data.forEach((material) => {
        if (material.grades && Array.isArray(material.grades) && materialsToInclude.includes(material.name)) {
            material.grades.forEach((grade) => {
                
                if (!uniqueGrades.has(grade.name)) {
                    uniqueGrades.add(grade.name);
                    uniqueGradesValues.push({
                        displayText: grade.name,
                        id: idCounter++
                    });
                }
            });
        }
    });

    return uniqueGradesValues;
}


/* istanbul ignore next */
function getTypeOptions(data, materialsToInclude, gradesToInclude) {
    if (!Array.isArray(data) || !Array.isArray(materialsToInclude) || !Array.isArray(gradesToInclude)) {
        return [];
    }

    let idCounter = 1;
    const uniqueTypes = new Set();
    const typeOptions = [];

    data.forEach((material) => {
        if (!materialsToInclude.includes(material.name) || !Array.isArray(material.grades)) return;

        material.grades.forEach((grade) => {
            if (!gradesToInclude.includes(grade.name) || !Array.isArray(grade.types)) return;

            grade.types.forEach((type) => {
                const typeName = type && type.name;
                if (!typeName) return;

                if (!uniqueTypes.has(typeName)) {
                    uniqueTypes.add(typeName);
                    typeOptions.push({
                        displayText: typeName,
                        id: idCounter++
                    });
                }
            });
        });
    });

    return typeOptions;
}

/* istanbul ignore next */
function getTradeNameOptions(data, materialsToInclude, gradesToInclude, materialTypesToInclude) {
    if (!Array.isArray(data)) return [];
    if (!Array.isArray(materialsToInclude)) return [];
    if (!Array.isArray(gradesToInclude)) return [];
    if (!Array.isArray(materialTypesToInclude)) return [];
  
    let idCounter = 1;
    const uniqueValues = [];
    const uniqueSet = new Set();
  
    data.forEach((material) => {
      if (
        material &&
        Array.isArray(material.grades) &&
        materialsToInclude.includes(material.name)
      ) {
        material.grades.forEach((grade) => {
          if (
            grade && Array.isArray(grade.types) && gradesToInclude.includes(grade.name)
          ) {
            grade.types.forEach((type) => {

              if (
                type && Array.isArray(type.tradeNames) && materialTypesToInclude.includes(type.name)
              ) {
                type.tradeNames.forEach((tradeName) => {
                  const name = tradeName && tradeName.name;
                  if (typeof name === "string" && !uniqueSet.has(name)) {
                    uniqueSet.add(name);
                    uniqueValues.push({
                      displayText: name,
                      id: idCounter++,
                    });
                  }
                });
              }
            });
          }
        });
      }
    });
  
    return uniqueValues;
  }

/* istanbul ignore next */
function getSizeOptions(
    data,
    materialsToInclude,
    gradesToInclude,
    materialTypesToInclude,
    tradeNamesToInclude
  ) {
    if (!Array.isArray(data)) return [];
    if (!Array.isArray(materialsToInclude)) return [];
    if (!Array.isArray(gradesToInclude)) return [];
    if (!Array.isArray(materialTypesToInclude)) return [];
    if (!Array.isArray(tradeNamesToInclude)) return [];
  
    let idCounter = 1;
    const uniqueValues = [];
    const uniqueSet = new Set();
  
    data.forEach((material) => {
      if (
        material &&
        Array.isArray(material.grades) && materialsToInclude.includes(material.name)
      ) {
        material.grades.forEach((grade) => {
          if (
            grade &&
            Array.isArray(grade.types) && gradesToInclude.includes(grade.name)
          ) {
            grade.types.forEach((type) => {
              if (
                type &&
                Array.isArray(type.tradeNames) && materialTypesToInclude.includes(type.name)
              ) {
                type.tradeNames.forEach((tradeName) => {
                  if (
                    tradeName &&
                    Array.isArray(tradeName.sizes) && tradeNamesToInclude.includes(tradeName.name)
                  ) {
                    tradeName.sizes.forEach((size) => {
                      if (typeof size === "string" && !uniqueSet.has(size)) {
                        uniqueSet.add(size);
                        uniqueValues.push({
                          displayText: size,
                          id: idCounter++,
                        });
                      }
                    });
                  }
                });
              }
            });
          }
        });
      }
    });
  
    return uniqueValues;
  }

/* istanbul ignore next */  
function getImportingCountries(data, exportingCountriesToInclude) {

    if (!Array.isArray(data)) return [];

    let id = 1;
    const uniqueCountry = new Set();

    return data
        .filter(exportingCountry=>exportingCountriesToInclude.includes(exportingCountry.name))
        .flatMap(exportingCountry =>
        (Array.isArray(exportingCountry.importingCountry) ? exportingCountry.importingCountry : []).filter(importingCountry => {
            if (!uniqueCountry.has(importingCountry)) {
                uniqueCountry.add(importingCountry);
                return true;
            }
            return false;
        }).map(importingCountry => ({
            displayText: importingCountry,
            id: id++
        }))
    );
    
}

/* istanbul ignore next */
function getCategoriesL2ForExImFilters(data, l0sToInclude, l1sToInclude) {
    if (!data || !Array.isArray(data)) return [];

    let idCounter = 1;
    const uniqueL2Values = [];
    const uniqueL2Names = new Set();

    const l0Filter = Array.isArray(l0sToInclude) ? l0sToInclude : [];
    const l1Filter = Array.isArray(l1sToInclude) ? l1sToInclude : [];

    data.forEach((l0Item) => {
        const isL0Included = l0Filter.length === 0 || l0Filter.includes(l0Item.name);

        if (isL0Included && l0Item.l1 && Array.isArray(l0Item.l1)) {
            
            l0Item.l1.forEach((l1Item) => {
                const isL1Included = l1Filter.length === 0 || l1Filter.includes(l1Item.name);

                if (isL1Included && l1Item.l2 && Array.isArray(l1Item.l2)) {
                    
                    l1Item.l2.forEach((l2Item) => {
                        if (!uniqueL2Names.has(l2Item.name)) {
                            uniqueL2Names.add(l2Item.name);
                            uniqueL2Values.push({
                                displayText: l2Item.name,
                                id: idCounter++
                            });
                        }
                    });
                }
            });
        }
    });

    return uniqueL2Values;
}


/* istanbul ignore next */
function getFilterModeValues(data, l0sToInclude, l1sToInclude, l2sToInclude, returnType) {
    if (!data || !Array.isArray(data)) return [];
    if (returnType !== 'hsCode' && returnType !== 'productDescription') {
        console.error("Invalid returnType specified. Use 'hsCode' or 'productDescription'.");
        return [];
    }

    const distinctValues = new Set();

    data.forEach((l0Item) => {
        // Check if the L0 name is in our inclusion list
        if (l0sToInclude.includes(l0Item.name)) {
            // Iterate through L1 items if they exist
            if (l0Item.l1 && Array.isArray(l0Item.l1)) {
                l0Item.l1.forEach((l1Item) => {
                    // Check if the L1 name is in our inclusion list
                    if (l1sToInclude.includes(l1Item.name)) {
                        // Iterate through L2 items if they exist
                        if (l1Item.l2 && Array.isArray(l1Item.l2)) {
                            l1Item.l2.forEach((l2Item) => {
                                // Check if the L2 name is in our inclusion list
                                if (l2sToInclude.includes(l2Item.name)) {
                                    // Check if the target array exists and is an array
                                    if (l2Item[returnType] && Array.isArray(l2Item[returnType])) {
                                        // Add all values from the target array to the Set to ensure uniqueness
                                        l2Item[returnType].forEach(value => {
                                            if (typeof value === 'string' && value.trim() !== '') {
                                                distinctValues.add(value.trim());
                                            }
                                        });
                                    }
                                }
                            });
                        }
                    }
                });
            }
        }
    });

    // Convert the Set back to an Array before returning
    return Array.from(distinctValues);
}


/* istanbul ignore next */
const changeFromDateOptionsUtil = (toDateMonthSelected, entireMonthList) => {
    const toDateSelected = toDateMonthSelected.displayText;
    const maxDate = new Date(toDateSelected);
    const filteredMonths = entireMonthList.filter((month) => {
        const monthDate = new Date(month.value);
        return monthDate <= maxDate;
    });
    filteredMonths.push(toDateMonthSelected);
    filteredMonths.sort((a, b) => new Date(a.value) - new Date(b.value));
    return filteredMonths;
}
/* istanbul ignore next */
const changeToDateOptionsUtil = (fromDateMonthSelected,entireMonthList) => {
    const toDateSelected1 = fromDateMonthSelected.displayText;
    const fromDate = new Date(toDateSelected1);
    const filteredMonths = entireMonthList.filter((month) => {
        const monthDate = new Date(month.value);
        return monthDate >= fromDate;
    });
    return filteredMonths;
};


/* istanbul ignore next */
function getProductsByGeography(data, selectedGeography) {
    const result = [];
    let idCounter = 1;
    if (Array.isArray(data) && selectedGeography) {
        // Find the matching region object
        const selectedRegion = data.find(item => item.name === selectedGeography);

        // If region exists and has a valid product array, process it
        if (selectedRegion && Array.isArray(selectedRegion.product)) {
            selectedRegion.product.forEach(product => {
                if (product && product.name) {
                    result.push({
                        displayText: product.name,
                        id: idCounter,
                        isBadge: false
                    });
                    idCounter++;
                }
            });
        }
    }

    return result;
}

/* istanbul ignore next */
function getGradesByGeography(data, selectedGeography) {
    const result = [];
    let idCounter = 1;

    if (Array.isArray(data) && selectedGeography) {
        // Find the matching region object
        const selectedRegion = data.find(item => item.name === selectedGeography);

        // If region exists and has a valid product array, process it
        if (selectedRegion && Array.isArray(selectedRegion.grade)) {
            selectedRegion.grade.forEach(grade => {
                if (grade && grade.name) {
                    result.push({
                        displayText: grade.name,
                        id: idCounter,
                        isBadge: false
                    });
                    idCounter++;
                }
            });
        }
    }

    return result;
}

/* istanbul ignore next */
function getGeographyByGrades(data, selectedGrade) {
    const grade = Array.isArray(data) ? data.find(item => item?.name === selectedGrade) : null;
    const geographies = Array.isArray(grade?.geography) ? grade.geography : [];
    const seenGeographies = new Set();

    return geographies.reduce((result, geography) => {
        if (geography?.name && !seenGeographies.has(geography.name)) {
            seenGeographies.add(geography.name);
            result.push({
                displayText: geography.name,
                id: result.length + 1,
                isBadge: false
            });
        }
        return result;
    }, []);
}

/* istanbul ignore next */
function getPriceTypeByGeoAndGrade(data, selectedGeo, selectedGrade) {
    const result = [];
    const seenPriceTypes = new Set();
    let idCounter = 1;

    if (Array.isArray(data) && selectedGeo && selectedGrade) {
        const gradeItem = data.find(item => item.name === selectedGrade);

        if (gradeItem && Array.isArray(gradeItem.geography)) {
            const geoItem = gradeItem.geography.find(item => item.name === selectedGeo);

            if (geoItem && Array.isArray(geoItem.priceType)) {
                // 3. Loop through price types and format them
                geoItem.priceType.forEach(priceTypeItem => {
                    if (priceTypeItem && priceTypeItem.name && !seenPriceTypes.has(priceTypeItem.name)) {
                        seenPriceTypes.add(priceTypeItem.name);
                        result.push({
                            displayText: priceTypeItem.name,
                            id: idCounter,
                            isBadge: false
                        });
                        idCounter++;
                    }
                });
            }
        }
    }

    return result;
}

/* istanbul ignore next */
function getPriceForecastSeriesByGeoAndProduct(data, selectedGeo, selectedProduct) {
    const result = [];
    const seenForecastSeries = new Set();
    let idCounter = 1;

    if (Array.isArray(data) && selectedGeo && selectedProduct) {
        const productItem = data.find(item => item.name === selectedProduct);

        if (productItem && Array.isArray(productItem.geography)) {
            const geoItem = productItem.geography.find(item => item.name === selectedGeo);

            if (geoItem && Array.isArray(geoItem.priceForecastSeries)) {
                geoItem.priceForecastSeries.forEach(seriesItem => {
                    if (seriesItem && seriesItem.name && !seenForecastSeries.has(seriesItem.name)) {
                        seenForecastSeries.add(seriesItem.name);
                        result.push({
                            displayText: seriesItem.name,
                            id: idCounter,
                            isBadge: false
                        });
                        idCounter++;
                    }
                });
            }
        }
    }

    return result;
}

/* istanbul ignore next */
function getPricePointByGeoProductAndPriceForecastSeries(data, selectedGeo, selectedProduct, selectedPriceForecastSeries) {
    const result = [];
    const seenPricePoints = new Set();
    let idCounter = 1;

    if (Array.isArray(data) && selectedGeo && selectedProduct && selectedPriceForecastSeries) {
        const productItem = data.find(item => item.name === selectedProduct);

        if (productItem && Array.isArray(productItem.geography)) {
            const geoItem = productItem.geography.find(item => item.name === selectedGeo);

            if (geoItem && Array.isArray(geoItem.priceForecastSeries)) {
                const priceForecastSeriesItem = geoItem.priceForecastSeries.find(
                    series => series.name === selectedPriceForecastSeries
                );

                if (priceForecastSeriesItem && Array.isArray(priceForecastSeriesItem.pricePoint)) {
                    priceForecastSeriesItem.pricePoint.forEach(pricePointItem => {
                        if (pricePointItem && pricePointItem.name && !seenPricePoints.has(pricePointItem.name)) {
                            seenPricePoints.add(pricePointItem.name);
                            result.push({
                                displayText: pricePointItem.name,
                                id: idCounter,
                                isBadge: false
                            });
                            idCounter++;
                        }
                    });
                }
            }
        }
    }

    return result;
}

/* istanbul ignore next */
function getUnitByGeoProductAndPriceForecastSeriesPricePoint(data, selectedGeo, selectedProduct, selectedPriceForecastSeries, selectedPricePoint) {
    const result = [];
    const seenUnits = new Set();
    let idCounter = 1;

    if (Array.isArray(data) && selectedGeo && selectedProduct && selectedPriceForecastSeries && selectedPricePoint) {
        const productItem = data.find(item => item.name === selectedProduct);

        if (productItem && Array.isArray(productItem.geography)) {
            const geoItem = productItem.geography.find(item => item.name === selectedGeo);

            if (geoItem && Array.isArray(geoItem.priceForecastSeries)) {
                const priceForecastSeriesItem = geoItem.priceForecastSeries.find(
                    series => series.name === selectedPriceForecastSeries
                );

                if (priceForecastSeriesItem && Array.isArray(priceForecastSeriesItem.pricePoint)) {
                    const pricePointItem = priceForecastSeriesItem.pricePoint.find(point => point.name === selectedPricePoint);

                    if (pricePointItem && Array.isArray(pricePointItem.unit)) {
                        pricePointItem.unit.forEach(unitItem => {
                            if (unitItem && !seenUnits.has(unitItem)) {
                                seenUnits.add(unitItem);
                                result.push({
                                    displayText: unitItem,
                                    id: idCounter,
                                    isBadge: false
                                });
                                idCounter++;
                            }
                        });
                    }
                }
            }
        }
    }

    return result;
}

/* istanbul ignore next */
function getPricePointByGeoGradeAndPriceType(data, selectedGeo, selectedGrade, selectedPriceType) {
    const result = [];
    const seenPricePoints = new Set();
    let idCounter = 1;

    if (Array.isArray(data) && selectedGeo && selectedGrade && selectedPriceType) {
        const gradeItem = data.find(item => item.name === selectedGrade);

        if (gradeItem && Array.isArray(gradeItem.geography)) {
            const geoItem = gradeItem.geography.find(item => item.name === selectedGeo);

            if (geoItem && Array.isArray(geoItem.priceType)) {
                const priceTypeItem = geoItem.priceType.find(priceType => priceType.name === selectedPriceType);

                if (priceTypeItem && Array.isArray(priceTypeItem.pricePoint)) {
                    priceTypeItem.pricePoint.forEach(pricePointItem => {
                        if (pricePointItem && pricePointItem.name && !seenPricePoints.has(pricePointItem.name)) {
                            seenPricePoints.add(pricePointItem.name);
                            result.push({
                                displayText: pricePointItem.name,
                                id: idCounter,
                                isBadge: false
                            });
                            idCounter++;
                        }
                    });
                }
            }
        }
    }

    return result;
}

/* istanbul ignore next */
function getPriceBasisByGeoGradePriceTypeAndPoint(data, selectedGeo, selectedGrade, selectedPriceType, selectedPricePoint) {
    const result = [];
    const seenPriceBasis = new Set();
    let idCounter = 1;

    if (Array.isArray(data) && selectedGeo && selectedGrade && selectedPriceType && selectedPricePoint) {
        const gradeItem = data.find(item => item.name === selectedGrade);

        if (gradeItem && Array.isArray(gradeItem.geography)) {
            const geoItem = gradeItem.geography.find(item => item.name === selectedGeo);

            if (geoItem && Array.isArray(geoItem.priceType)) {
                const priceTypeItem = geoItem.priceType.find(priceType => priceType.name === selectedPriceType);

                if (priceTypeItem && Array.isArray(priceTypeItem.pricePoint)) {
                    const pricePointItem = priceTypeItem.pricePoint.find(pricePoint => pricePoint.name === selectedPricePoint);

                    if (pricePointItem && Array.isArray(pricePointItem.priceBasis)) {
                        pricePointItem.priceBasis.forEach(priceBasisItem => {
                            if (priceBasisItem && priceBasisItem.name && !seenPriceBasis.has(priceBasisItem.name)) {
                                seenPriceBasis.add(priceBasisItem.name);
                                result.push({
                                    displayText: priceBasisItem.name,
                                    id: idCounter,
                                    isBadge: false
                                });
                                idCounter++;
                            }
                        });
                    }
                }
            }
        }
    }

    return result;
}

/* istanbul ignore next */
function getUnitByGeoGradePriceTypeAndPointAndBasis(data, selectedGeo, selectedGrade, selectedPriceType, selectedPricePoint, selectedPriceBasis) {
    const result = [];
    const seenUnits = new Set();
    let idCounter = 1;

    if (Array.isArray(data) && selectedGeo && selectedGrade && selectedPriceType && selectedPricePoint && selectedPriceBasis) {
        const gradeItem = data.find(item => item.name === selectedGrade);

        if (gradeItem && Array.isArray(gradeItem.geography)) {
            const geoItem = gradeItem.geography.find(item => item.name === selectedGeo);

            if (geoItem && Array.isArray(geoItem.priceType)) {
                const priceTypeItem = geoItem.priceType.find(priceType => priceType.name === selectedPriceType);

                if (priceTypeItem && Array.isArray(priceTypeItem.pricePoint)) {
                    const pricePointItem = priceTypeItem.pricePoint.find(pricePoint => pricePoint.name === selectedPricePoint);

                    if (pricePointItem && Array.isArray(pricePointItem.priceBasis)) {
                        const priceBasisItem = pricePointItem.priceBasis.find(priceBasis => priceBasis.name === selectedPriceBasis);

                        if (priceBasisItem && Array.isArray(priceBasisItem.unit)) {
                            priceBasisItem.unit.forEach(unitItem => {
                                if (unitItem && !seenUnits.has(unitItem)) {
                                    seenUnits.add(unitItem);
                                    result.push({
                                        displayText: unitItem,
                                        id: idCounter,
                                        isBadge: false
                                    });
                                    idCounter++;
                                }
                            });
                        }
                    }
                }
            }
        }
    }

    return result;
}


/* istanbul ignore next */
function getGradesByGeoAndProduct(data, selectedGeo, selectedProduct) {
    const result = [];
    const seenGrades = new Set();
    let idCounter = 1;

    if (Array.isArray(data) && selectedGeo && selectedProduct) {
        const productItem = data.find(item => item.name === selectedProduct);

        if (productItem && Array.isArray(productItem.geography)) {
            const geoItem = productItem.geography.find(item => item.name === selectedGeo);

            if (geoItem && Array.isArray(geoItem.grade)) {
                // 3. Loop through grades and format them
                geoItem.grade.forEach(gradeItem => {
                    if (gradeItem && gradeItem.name) {
                        // Prevent duplicates (e.g., if "Blank" or "Fiber Grade" appears multiple times)
                        if (!seenGrades.has(gradeItem.name)) {
                            seenGrades.add(gradeItem.name);
                            result.push({
                                displayText: gradeItem.name,
                                id: idCounter,
                                isBadge: false
                            });
                            idCounter++;
                        }
                    }
                });
            }
        }
    }

    return result;
}


/* istanbul ignore next */
function getConceptsByGeoProductAndGrade(data, selectedGeo, selectedProduct, selectedGrade) {
    const result = [];
    const seenConcepts = new Set();
    let idCounter = 1;

    if (Array.isArray(data) && selectedGeo && selectedProduct && selectedGrade) {
        const productItem = data.find(item => item.name === selectedProduct);

        if (productItem && Array.isArray(productItem.geography)) {
            const geoItem = productItem.geography.find(item => item.name === selectedGeo);

            if (geoItem && Array.isArray(geoItem.grade)) {
                // 3. Find the selected grade
                const gradeItem = geoItem.grade.find(g => g.name === selectedGrade);

                if (gradeItem && Array.isArray(gradeItem.concept)) {
                    // 4. Loop through concepts and format them
                    gradeItem.concept.forEach(conceptItem => {
                        if (conceptItem && conceptItem.name) {
                            // Deduplicate concepts (e.g., if "Contract-Market" appears multiple times)
                            if (!seenConcepts.has(conceptItem.name)) {
                                seenConcepts.add(conceptItem.name);
                                result.push({
                                    displayText: conceptItem.name,
                                    id: idCounter,
                                    isBadge: false
                                });
                                idCounter++;
                            }
                        }
                    });
                }
            }
        }
    }

    return result;
}

/* istanbul ignore next */
function getTermsByGeoProductGradeAndConcept(data, selectedGeo, selectedProduct, selectedGrade, selectedConcept) {
    const result = [];
    const seenTerms = new Set();
    let idCounter = 1;

    if (Array.isArray(data) && selectedGeo && selectedProduct && selectedGrade && selectedConcept) {
        const productItem = data.find(item => item.name === selectedProduct);

        if (productItem && Array.isArray(productItem.geography)) {
            const geoItem = productItem.geography.find(item => item.name === selectedGeo);

            if (geoItem && Array.isArray(geoItem.grade)) {
                // 3. Find the selected grade
                const gradeItem = geoItem.grade.find(g => g.name === selectedGrade);

                if (gradeItem && Array.isArray(gradeItem.concept)) {
                    // 4. Find the selected concept
                    const conceptItem = gradeItem.concept.find(c => c.name === selectedConcept);

                    if (conceptItem && Array.isArray(conceptItem.terms)) {
                        // 5. Loop through terms and format them
                        conceptItem.terms.forEach(termItem => {
                            if (termItem && termItem.name) {
                                // Deduplicate terms (e.g., "C&F Asia/Pacific")
                                if (!seenTerms.has(termItem.name)) {
                                    seenTerms.add(termItem.name);
                                    result.push({
                                        displayText: termItem.name,
                                        id: idCounter,
                                        isBadge: false
                                    });
                                    idCounter++;
                                }
                            }
                        });
                    }
                }
            }
        }
    }

    return result;
}

/* istanbul ignore next */
function getUnitsByGeoProductGradeConceptAndTerm(data, selectedGeo, selectedProduct, selectedGrade, selectedConcept, selectedTerm) {
    const result = [];
    const seenUnits = new Set();
    let idCounter = 1;

    if (Array.isArray(data) && selectedGeo && selectedProduct && selectedGrade && selectedConcept && selectedTerm) {
        const productItem = data.find(item => item.name === selectedProduct);

        if (productItem && Array.isArray(productItem.geography)) {
            const geoItem = productItem.geography.find(item => item.name === selectedGeo);

            if (geoItem && Array.isArray(geoItem.grade)) {
                // 3. Find the selected grade
                const gradeItem = geoItem.grade.find(g => g.name === selectedGrade);

                if (gradeItem && Array.isArray(gradeItem.concept)) {
                    // 4. Find the selected concept
                    const conceptItem = gradeItem.concept.find(c => c.name === selectedConcept);

                    if (conceptItem && Array.isArray(conceptItem.terms)) {
                        // 5. Find the selected term
                        const termItem = conceptItem.terms.find(t => t.name === selectedTerm);

                        // 6. Access the unit array (strings array)
                        if (termItem && Array.isArray(termItem.unit)) {
                            termItem.unit.forEach(unitString => {
                                if (unitString && !seenUnits.has(unitString)) {
                                    seenUnits.add(unitString);
                                    result.push({
                                        displayText: unitString,
                                        id: idCounter,
                                        isBadge: false
                                    });
                                    idCounter++;
                                }
                            });
                        }
                    }
                }
            }
        }
    }

    return result;
}

/* istanbul ignore next */
function getProductDescriptionsByGeoAndProduct(data, selectedGeo, selectedProduct) {
    const result = [];
    const seenProductDescriptions = new Set();
    let idCounter = 1;

    if (Array.isArray(data) && selectedGeo && selectedProduct) {
        const geoItem = data.find(item => item.name === selectedGeo);

        if (geoItem && Array.isArray(geoItem.product)) {
            const productItem = geoItem.product.find(product => product.name === selectedProduct);

            if (productItem && Array.isArray(productItem.productDescriptions)) {
                productItem.productDescriptions.forEach(descItem => {
                    if (descItem && descItem.name && !seenProductDescriptions.has(descItem.name)) {
                        seenProductDescriptions.add(descItem.name);
                        result.push({
                            displayText: descItem.name,
                            id: idCounter,
                            isBadge: false
                        });
                        idCounter++;
                    }
                });
            }
        }
    }

    return result;
}

/* istanbul ignore next */
function getUnitOfMeasureByGeoProductProductDescriptions(data, selectedGeo, selectedProduct, selectedProductDescription) {
    const result = [];
    const seenUnits = new Set();
    let idCounter = 1;
    
    if (Array.isArray(data) && selectedGeo && selectedProduct && selectedProductDescription) {
        const geoItem = data.find(item => item.name === selectedGeo);

        if (geoItem && Array.isArray(geoItem.product)) {
            const productItem = geoItem.product.find(product => product.name === selectedProduct);

            if (productItem && Array.isArray(productItem.productDescriptions)) {
                const descItem = productItem.productDescriptions.find(
                    desc => desc.name === selectedProductDescription
                );

                if (descItem && Array.isArray(descItem.units)) {
                    descItem.units.forEach(unitItem => {
                        if (unitItem && !seenUnits.has(unitItem)) {
                            seenUnits.add(unitItem);
                            result.push({
                                displayText: unitItem,
                                id: idCounter,
                                isBadge: false
                            });
                            idCounter++;
                        }
                    });
                }
            }
        }
    }

    return result;
}

/* istanbul ignore next */
function getGeographyByProducts(data, selectedProduct) {
    const product = Array.isArray(data) ? data.find(item => item?.name === selectedProduct) : null;
    const geographies = Array.isArray(product?.geography) ? product.geography : [];
    const seenGeographies = new Set();

    return geographies.reduce((result, geography) => {
        if (geography?.name && !seenGeographies.has(geography.name)) {
            seenGeographies.add(geography.name);
            result.push({
                displayText: geography.name,
                id: result.length + 1,
                isBadge: false
            });
        }
        return result;
    }, []);
}

/* istanbul ignore next */
function getProductDescriptionsByProductAndGeo(data, selectedProduct, selectedGeo) {
    const product = Array.isArray(data) ? data.find(item => item?.name === selectedProduct) : null;
    const geography = Array.isArray(product?.geography)
        ? product.geography.find(item => item?.name === selectedGeo)
        : null;
    const descriptions = Array.isArray(geography?.productDescriptions) ? geography.productDescriptions : [];
    const seenDescriptions = new Set();

    return descriptions.reduce((result, description) => {
        if (description?.name && !seenDescriptions.has(description.name)) {
            seenDescriptions.add(description.name);
            result.push({
                displayText: description.name,
                id: result.length + 1,
                isBadge: false
            });
        }
        return result;
    }, []);
}

/* istanbul ignore next */
function getUnitOfMeasureByProductGeoProductDescriptions(data, selectedProduct, selectedGeo, selectedProductDescription) {
    const product = Array.isArray(data) ? data.find(item => item?.name === selectedProduct) : null;
    const geography = Array.isArray(product?.geography)
        ? product.geography.find(item => item?.name === selectedGeo)
        : null;
    const description = Array.isArray(geography?.productDescriptions)
        ? geography.productDescriptions.find(item => item?.name === selectedProductDescription)
        : null;
    const units = Array.isArray(description?.units) ? description.units : [];
    const seenUnits = new Set();

    return units.reduce((result, unit) => {
        if (unit && !seenUnits.has(unit)) {
            seenUnits.add(unit);
            result.push({
                displayText: unit,
                id: result.length + 1,
                isBadge: false
            });
        }
        return result;
    }, []);
}



export {
    getRoles,
    getYears,
    getSectors,
    getSectorsV2,
    getBusinessUnitsBySector,
    getBusinessUnitsBySectorV2,
    getCountriesBySectorBuV2,
    getCategoriesBySectorAndBusinessUnit,
    getCategoryL0ListV2,
    getCategoryL1ListV2,
    getCategoryL2ListV2,
    getCategoriesLevel1,
    getCategoriesLevel2,
    getCategoriesLevel2ForSustainability,
    getCategoriesL0ForSPM,
    getCategoriesL1ForSPM,
    getCategoriesL2ForSPM,
    formatUserDataForVendorListApi,
    formatUserDataForVendorListApiwithCountry,
    getCategoriesL1ForSmartcube,
    getCategoriesL2ForSmartcube,
    getBusinessUnitForResilience,
    getSectorsForResilience,
    removeDuplicateDisplayTextAndAdjustIds,
    getDropdownOptions,
    getSectorsForSupplierFilters,
    getBUsForSupplierFilters,
    getCategoriesL0ForSupplierFilters,
    getCategoriesL1ForSupplierFilters,
    getCategoriesL2ForSupplierFilters,
    getRegenTypesForSupplierFilters,
    getAllRegenTypeSuppliersForSupplierFilters,
    getSuppliersUsingTypesForSupplierFilters,
    getCommoditiesForRISI,
    getIndexesForRISI,
    getLocationsForRISI,
    getLocationForNewsFilters,
    getGradeOptions,
    getTypeOptions,
    getTradeNameOptions,
    getSizeOptions,
    getImportingCountries,
    getCategoriesL2ForExImFilters,
    getFilterModeValues,
    changeFromDateOptionsUtil,
    changeToDateOptionsUtil,
    getProductsByGeography,
    getGeographyByProducts,
    getGeographyByGrades,
    getGradesByGeography,
    getPriceTypeByGeoAndGrade,
    getPriceForecastSeriesByGeoAndProduct,
    getProductDescriptionsByGeoAndProduct,
    getProductDescriptionsByProductAndGeo,
    getUnitOfMeasureByGeoProductProductDescriptions,
    getUnitOfMeasureByProductGeoProductDescriptions,
    getPricePointByGeoProductAndPriceForecastSeries,
    getUnitByGeoProductAndPriceForecastSeriesPricePoint,
    getPricePointByGeoGradeAndPriceType,
    getPriceBasisByGeoGradePriceTypeAndPoint,
    getUnitByGeoGradePriceTypeAndPointAndBasis,
    getGradesByGeoAndProduct,
    getConceptsByGeoProductAndGrade,
    getTermsByGeoProductGradeAndConcept,
    getUnitsByGeoProductGradeConceptAndTerm,
    extractCountriesByRole,
    extractL0ByRole,
    extractSectorsByRole,
    extractBUsByRole,
    extractL1ByRole,
    extractL2ByRole
}